import './App.css';
import MainCard from "./components/MainCard";
import {BrowserRouter, Link, Route, Routes, useNavigate} from "react-router-dom";
import FormPersona from "./components/FormPersona";
import React, {Component, useEffect, useState} from "react";
import StarterCard from "./components/StarterCard";
import Risultati from "./components/Risultati";
import commonStyles from "./commonStyles";
import ListaPersone from "./components/ListaPersone";
import {useSpring, animated} from "react-spring";
import {easings} from "@react-spring/web";

const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}

function App() {
    const [cards, setCards] = useState([
        { title: "Choose Method", btn1: "Equally", btn1To: "/Equally", btn2: "Individually", btn2To: "/Individually" },
        { title: "Equally Divided", btn1: "Add Friend", btn1To: "/Equally/addFriend", btn2: "Calculate"},
        { title: "Individually", btn1: "Add Friend", btn1To: "/Individually/addFriend", btn2: "Calculate" }
    ]);

    //Impostazione dello stato
    const initialState = []
    const [persone, setPersone] = useState(initialState)

    //Variabili per Errori
    const [formErrorNome, setformErrorNome] = useState("")
    const [formErrorSpesaPers, setformErrorSpesaPers] = useState("")
    const [formErrorSpesaTot, setformErrorSpesaTot] = useState("")
    const [errorCalcola, setErrorCalcola] = useState("coolbtn")
    const [errorBadge, setErrorBadge] = useState("text-bg-light")

    //Variabili per Alerts
    const [AlertMessage, setAlertMessage] = useState("")
    const [infoError, setInfoError] = useState("")
    const [widthInfo, setWidthInfo] = useState(28)
    const [heightInfo, setHeightInfo] = useState(28)
    const [openSuccAlert, toggleSuccAlert] = useState(false)
    const [openErrAlert, toggleErrAlert] = useState(false)
    const [openInfoAlert, toggleInfoAlert] = useState(false)
    const [knowAbout, toggleKnowAbout] = useState(false)

    let navigate = useNavigate();

    useEffect(() => {
        setPersone(JSON.parse(sessionStorage.getItem("persone")))

        if(readCookie("firstVisitHome") == null) {
            toggleKnowAbout(!knowAbout)
            createCookie("firstVisitHome", false, 30)
        } else {
            createCookie("firstVisitHome", false, 30)
        }
    }, [])

    //Animazioni
    const errInfo = useSpring({
        loop: true,
        to: [
            { opacity: 0 },
            { opacity: 1 },
        ],
        from: { opacity: 1 },

        config: {
            duration: 250
        }
    })

    const errAlertStyles = useSpring({
        opacity: openErrAlert? 1 : 0,
        marginTop: openErrAlert? 100 : -300,
        config: {
            duration: 500,
            easing: easings.easeInOutQuart
        }
    })

    const succAlertStyles = useSpring({
        opacity: openSuccAlert? 1 : 0,
        marginBottom: openSuccAlert? 0 : -100,
        config: {
            duration: 500,
            easing: easings.easeInOutQuart
        }
    })

    const infoAlertStyles = useSpring({
        opacity: openInfoAlert? 1 : 0,
        marginBottom: openInfoAlert? 0 : -100,
        config: {
            duration: 500,
            easing: easings.easeInOutQuart
        }
    })

    //Funzioni per Stato / Memoria / cookies
    const downloadSession = () => {
        setPersone(JSON.parse(sessionStorage.getItem("persone")))
    }

    const saveSession = () => {
        sessionStorage.setItem("persone", JSON.stringify(persone));
    }

    const resetState = () => {
        setPersone(initialState)
        sessionStorage.setItem("persone", JSON.stringify(initialState))
        setErrorCalcola("btn-outline-light")
        setErrorBadge("text-bg-light")
    }

    function createCookie(name,value,days) {
        if (days) {
            var date = new Date();
            date.setTime(date.getTime()+(days*24*60*60*1000));
            var expires = "; expires="+date.toGMTString();
        }
        else var expires = "";
        document.cookie = name+"="+value+expires+"; path=/";
    }

    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    function eraseCookie(name) {
        createCookie(name,"",-1);
    }

    //Funzioni per avvio Alert
    const errorAlert = async (message) => {
        //Info Button Attributes
        setWidthInfo(32)
        setHeightInfo(32)
        setInfoError("err")

        //Alert Attributes
        setAlertMessage(message)
        toggleErrAlert(true)
        await sleep(2500)
        toggleErrAlert(false)

        //Info Button Attributes
        setInfoError("")
        setWidthInfo(28)
        setHeightInfo(28)
    }

    const infoAlert = async (message) => {
        setAlertMessage(message)
        toggleInfoAlert(true)
        await sleep(2500)
        toggleInfoAlert(false)
    }

    //Aggiungere una Persona
    const handlePersona = async (flag) => {
        var isNomeNew = true

        //Acquisisco valori Necessari
        var nome = document.modulo.nome.value;
        nome = nome.toLowerCase()
        var spesaTot = parseFloat(document.modulo.spesaTot.value);


        for (let i = 0; i < persone.length; i++) {
            if (nome === persone[i].nome){
                isNomeNew = false
            }
        }

        //Controllo Nome e Handle dell'Errore
        if ((nome === "") || (nome === "undefined")) {
            document.modulo.nome.focus();
            setformErrorNome(" is-invalid")
            errorAlert("Name Cannot be Empty")
            return false;
        } else if (!isNomeNew) {
            document.modulo.nome.focus();
            setformErrorNome(" is-invalid")
            errorAlert("The Name Already Exists")
            return false;
        } else {
            setformErrorNome("")
        }

        //Controllo Spesa Personale (se necessario) e Handle dell'Errore
        if (flag) {
            var spesaPers = parseFloat(document.modulo.spesaPers.value);

            if (isNaN(spesaPers) || (spesaPers === "undefined")) {
                document.modulo.spesaPers.focus();
                setformErrorSpesaPers(" is-invalid")
                errorAlert("Your Charge is not a Number")
                return false;
            } else if (spesaPers === "") {
                document.modulo.spesaPers.focus();
                setformErrorSpesaPers(" is-invalid")
                errorAlert("Your Charge cannot be Empty")
                return false;
            } else if (spesaPers < 0) {
                document.modulo.spesaPers.focus();
                setformErrorSpesaPers(" is-invalid")
                errorAlert("Your Charge cannot be Negative")
                return false;
            } else {
                setformErrorSpesaPers("")
            }
        }

        //Controllo Spesa Totale e Handle dell'Errore
        if (isNaN(spesaTot) || (spesaTot === "undefined")) {
            document.modulo.spesaTot.focus();
            setformErrorSpesaTot(" is-invalid")
            errorAlert("Money Given is not a Number")
            return false;
        } else if (spesaTot === "") {
            document.modulo.spesaTot.focus();
            setformErrorSpesaTot(" is-invalid")
            errorAlert("Money Given cannot be Empty")
            return false;
        } else if (spesaTot < 0) {
            document.modulo.spesaTot.focus();
            setformErrorSpesaTot(" is-invalid")
            errorAlert("Money Given cannot be Negative")
            return false;
        } else {
            setformErrorSpesaTot("")
        }


        //Inserisco il nuovo elemento in un Array Momentaneo
        let newArray
        (flag) ? newArray = [...persone, { id: persone.length, nome: nome, spesaPers: spesaPers, spesaTot: spesaTot, debito: 0, ricevere: 0, to: []}] : newArray = [...persone, { id: persone.length, nome: nome, spesaTot: spesaTot, debito: 0, ricevere: 0, to: []}];

        //Reimposto il Form allo stato iniziale
        document.modulo.nome.value = ""
        if (flag)
            document.modulo.spesaPers.value = ""
        document.modulo.spesaTot.value = ""

        setPersone(newArray);

        sessionStorage.setItem("persone", JSON.stringify(newArray));

        setAlertMessage("New Friend Added!")
        toggleSuccAlert(true)

        //Torno alla Pagina Precedente
        handleBack()

        await sleep(2500)

        toggleSuccAlert(false)

    }

    //Cancellare la Persona
    const handleCancellaPersona = (persona) => {
        const cards = persone.filter(pers => pers.id !== persona.id)
        setPersone(cards)
        sessionStorage.setItem("persone", JSON.stringify(cards));
    }

    //Navigazione indietro nelle Pagine
    const handleBack = () => {
        navigate(-1)
        setErrorCalcola("btn-outline-light")
        setErrorBadge("text-bg-light")
        setformErrorNome("")
        setformErrorSpesaPers("")
        setformErrorSpesaTot("")
    }

    //Calcola i Risultati (Algoritmo Principale)
    const handleCalcola = (flag) => {
        if (persone.length > 0) {
            let totale = 0, spesaPc
            let array = persone
            for (let i = 0; i < array.length; i++) {
                array[i].to = []
            }

            //Calcolo per diviso
            if (!flag) {
                for (let i = 0; i < persone.length; i++) {
                    totale += persone[i].spesaTot
                }

                spesaPc = (totale / persone.length).toFixed(2)

                for (let i = 0; i < persone.length; i++) {
                    array[i].spesaPers = spesaPc
                }
            }

            //Calcolo debito per ogni persona
            for (let i = 0; i < persone.length; i++) {
                array[i].debito = (array[i].spesaTot - array[i].spesaPers).toFixed(2)
                if (array[i].debito < 0){
                    array[i].debito *= -1
                } else {
                    array[i].debito = 0
                }
            }

            // Calcolo i soldi da ricevere per ogni persona
            for (let i = 0; i < persone.length; i++) {
                array[i].ricevere = (array[i].spesaTot - array[i].spesaPers).toFixed(2)
                if (array[i].ricevere < 0){
                    array[i].ricevere = 0
                }
            }

            const sommaArray = (array) => {
                let somma = 0
                for (let i = 0; i < array.length; i++) {
                    somma += array[i]
                }

                return somma
            }


            let arrayRicevere = []
            for (let i = 0; i < array.length; i++) {
                arrayRicevere[i] = parseFloat(array[i].ricevere)
            }


            let arrayDebito = []
            for (let i = 0; i < array.length; i++) {
                arrayDebito[i] = parseFloat(array[i].debito)
            }


            let max = (array) => {
                let valMax = 0
                let index
                for (let i = 0; i < array.length; i++) {
                    if (array[i] > valMax) {
                        valMax = array[i]
                        index = i
                    }
                }

                return index
            }

            while (sommaArray(arrayRicevere) !== 0 && sommaArray(arrayDebito) !== 0) {
                //Trovo max di ricevere e debito
                let maxIRicevere = max(arrayRicevere)
                let maxIDebito = max(arrayDebito)

                let resto = arrayRicevere[maxIRicevere] - arrayDebito[maxIDebito]

                if (resto > 0) {
                    array[maxIDebito].to = [...array[maxIDebito].to, {nome: array[maxIRicevere].nome, daDare: arrayDebito[maxIDebito].toFixed(2)}]
                    arrayRicevere[maxIRicevere] = resto
                    arrayDebito[maxIDebito] = 0
                } else if (resto < 0) {
                    array[maxIDebito].to = [...array[maxIDebito].to, {nome: array[maxIRicevere].nome, daDare: arrayRicevere[maxIRicevere].toFixed(2)}]
                    arrayRicevere[maxIRicevere] = 0
                    arrayDebito[maxIDebito] = (-1*resto)
                } else {
                    array[maxIDebito].to = [...array[maxIDebito].to, {nome: array[maxIRicevere].nome, daDare: arrayRicevere[maxIRicevere].toFixed(2)}]
                    arrayRicevere[maxIRicevere] = 0
                    arrayDebito[maxIDebito] = 0
                }
            }

            setPersone(array)
            navigate("/Results")
        } else {
            setErrorCalcola("btn btn-outline-danger")
            setErrorBadge("text-bg-danger")
        }
    }

    return (
        <>
            <div className="App">
                <div className="container" style={{ textAlign: 'center' }}>
                        <h1 className={"mainTitle"} >
                            <a href="/" className="mainTitle-link">
                                <svg id="Livello_1" data-name="Livello 1" xmlns="http://www.w3.org/2000/svg" fill={"#00addf"}
                                     style={{width: '100%', height: 'auto'}}
                                     viewBox="0 0 4300.39 850">
                                    <defs>
                                        <style></style>
                                    </defs>
                                    <path className="cls-1"
                                          d="M473.42,280c0,42.78,27.73,77.45,62,77.45H724.72c76.8,0,142.54,59.24,169.53,143.15a277,277,0,0,1,13.13,85.11C907.38,711.85,825.61,814,724.72,814H37.92l84.3-158.42H703c34.24,0,62-34.71,62-77.45s-27.78-77.5-62-77.5H473.42c-77.38,0-143.75-59.08-171.69-143.15a281.05,281.05,0,0,1-14.24-89.2,286.09,286.09,0,0,1,7.57-65.7C317.75,106.28,389,36,473.42,36h610.32L995.15,202.56H535.39C501.15,202.56,473.42,237.22,473.42,280Z"/>
                                    <path className="cls-2"
                                          d="M474.87,280a93.9,93.9,0,0,0,3.27,24.85,82.18,82.18,0,0,0,10.05,22.9A67.69,67.69,0,0,0,505.11,346a52.3,52.3,0,0,0,22.75,9.6c.51.07,1,.17,1.54.23L531,356c1,.12,2.06.16,3.1.18,2.06.09,4.24,0,6.35.05h12.76l25.52,0,51.05,0,51-.05,25.53-.07,12.76,0c2.13,0,4.25,0,6.39,0l6.44.14a154.11,154.11,0,0,1,50.1,11,170.3,170.3,0,0,1,44.11,26.31A192.9,192.9,0,0,1,845,411.07a219.2,219.2,0,0,1,16.47,19.79,221.48,221.48,0,0,1,14.09,21.55,237.89,237.89,0,0,1,11.71,22.94,273.84,273.84,0,0,1,23,99.89,284.85,284.85,0,0,1-14,101.84,259.68,259.68,0,0,1-21.34,47.2,226.29,226.29,0,0,1-31.3,41.52,186.62,186.62,0,0,1-41.06,32.31,161.48,161.48,0,0,1-49.12,18.65l-6.53,1.08c-1.09.17-2.17.39-3.27.51l-3.29.34c-2.2.2-4.39.49-6.59.62l-6.62.26c-2.24.11-4.34.1-6.47.11l-6.38.05-12.76.09-51,.35L446.3,821.26,37.92,822.87l-14.75,0,6.91-13.11,83.67-158.75,2.67-5.07h5.8l574.86-1.86c2.93,0,6.26,0,8.28-.11a40.39,40.39,0,0,0,19.7-6.75,52.48,52.48,0,0,0,11-9.67A64.5,64.5,0,0,0,744.55,615a78.47,78.47,0,0,0,8.34-29.87,84.26,84.26,0,0,0-3.37-31.08,68,68,0,0,0-14.86-26.34c-6.72-7.25-15.15-12.39-24.07-14.11a37.35,37.35,0,0,0-6.75-.71l-.85,0h-3.36l-4.5,0-18,.09-35.93.16-143.71.69-18,.09c-3,0-5.85.07-9.23,0l-4.89-.1-4.88-.33a163.32,163.32,0,0,1-38.3-7.45c-.78-.25-1.56-.48-2.33-.74l-2.29-.82-4.59-1.65L408.53,501c-1.5-.61-3-1.22-4.47-1.93L399.65,497c-1.48-.68-2.89-1.46-4.34-2.19-2.91-1.44-5.7-3.07-8.51-4.68-1.42-.78-2.77-1.66-4.14-2.52l-4.1-2.59-4-2.73-2-1.37c-.65-.47-1.29-1-1.94-1.44l-3.87-2.89c-1.29-1-2.51-2-3.77-3s-2.52-2-3.72-3.07l-3.63-3.17a217.11,217.11,0,0,1-26.24-27.93,241.53,241.53,0,0,1-21.19-31.68,265.14,265.14,0,0,1-16.11-34.36c-1.19-2.94-2.2-5.92-3.26-8.89s-2-6-3-9c-1.9-6-3.54-12.12-5-18.25a301.24,301.24,0,0,1-8.14-74.92,296.94,296.94,0,0,1,10.71-74.66,268.51,268.51,0,0,1,30.22-69.59A225.89,225.89,0,0,1,364.2,60.48a191.84,191.84,0,0,1,32.79-21c2.87-1.55,5.9-2.8,8.87-4.18,1.47-.71,3-1.27,4.53-1.89L415,31.56,419.61,30c1.56-.51,3.09-1.11,4.68-1.53L429,27.05c.79-.22,1.57-.46,2.37-.67l2.4-.56a167.31,167.31,0,0,1,39.11-4.76l36,.08q143.72.39,287.43,1.46Q940,23.83,1083.74,26l16.84.25-8,14.49-91.12,165.19-2.13,3.87-4.19-.06-142.4-2.09-71.21-.91-71.2-.8-71.2-.68-71.2-.54-17.8-.11-8.9-.06c-3,0-6-.07-8.78,0a49.5,49.5,0,0,0-16.61,3.9c-.67.26-1.32.56-2,.88s-1.29.62-1.93.95c-1.25.71-2.53,1.37-3.72,2.18a55.83,55.83,0,0,0-6.95,5.13,68,68,0,0,0-6.18,6.06,72.35,72.35,0,0,0-5.36,6.84,78.54,78.54,0,0,0-8.26,15.32A92.14,92.14,0,0,0,474.87,280Zm-2.9,0a95,95,0,0,1,6.56-35.36,81.58,81.58,0,0,1,8.47-16,75.88,75.88,0,0,1,5.55-7.21A71.5,71.5,0,0,1,499,215a59.36,59.36,0,0,1,7.31-5.49c1.26-.86,2.62-1.58,3.94-2.35.68-.36,1.37-.69,2.05-1s1.38-.67,2.09-1a53.17,53.17,0,0,1,17.82-4.42c3.12-.16,6-.13,9-.16l8.9,0,17.8-.12,71.2-.54,71.2-.67,71.2-.8,71.21-.91,142.4-2.09-6.33,3.8,86.07-167.88L1083.74,46Q940,48.14,796.31,49.44T508.88,50.9L473,51a139.38,139.38,0,0,0-32,4l-2,.47c-.66.16-1.3.37-1.95.55l-3.89,1.14c-1.31.34-2.57.85-3.85,1.27l-3.84,1.33-3.77,1.51c-1.26.52-2.54,1-3.76,1.57-2.45,1.17-5,2.19-7.36,3.5A163.5,163.5,0,0,0,383,84.12C365.81,97.85,351.13,115,339.3,134a238.78,238.78,0,0,0-27,61.73,267.54,267.54,0,0,0-9.95,67.16,271.94,271.94,0,0,0,6.84,67.64c1.29,5.52,2.72,11,4.38,16.42.84,2.7,1.68,5.42,2.63,8.09s1.82,5.38,2.86,8a243.49,243.49,0,0,0,14.12,30.75A211.29,211.29,0,0,0,351.66,422a188.08,188.08,0,0,0,22.63,24.61c16.43,14.95,35.6,26.73,56.38,33.58a136.27,136.27,0,0,0,32,6.56l4.08.32,4.09.12c2.61.12,5.78.09,8.73.11l18,.09,143.71.69,35.93.17,18,.08,4.5,0H703l1.39.05a60.78,60.78,0,0,1,11.08,1.27,65.62,65.62,0,0,1,10.62,3.18,70.64,70.64,0,0,1,9.82,4.87,75.14,75.14,0,0,1,16.48,13.57,92,92,0,0,1,20,35.79,107.9,107.9,0,0,1,4.07,40,102,102,0,0,1-11.19,38.79,88.75,88.75,0,0,1-11.68,17,75.9,75.9,0,0,1-16,13.81,65.47,65.47,0,0,1-19.93,8.58,64.63,64.63,0,0,1-10.89,1.63c-4,.17-6.63.09-9.68.09l-574.86-1.86,8.46-5.08L45.77,818.16,37.92,805.1l408.38,1.6,204.18,1.09,51,.36,12.76.09,6.38,0c2.13,0,4.28.05,6.29,0l6.14-.15c2-.09,4.08-.33,6.12-.49l3.06-.27c1-.1,2-.29,3-.43l6.07-.92a152.39,152.39,0,0,0,46.14-16.76c14.49-7.92,27.59-18.31,39.38-30a218.07,218.07,0,0,0,30.64-39.35,251.56,251.56,0,0,0,21.36-45.33,277.88,277.88,0,0,0,15.2-99.1,267.86,267.86,0,0,0-21.25-98.19,238.11,238.11,0,0,0-11.18-22.66c-2-3.7-4.25-7.28-6.46-10.87l-3.48-5.28c-1.17-1.75-2.43-3.44-3.63-5.17a217.18,217.18,0,0,0-16-19.59,190.45,190.45,0,0,0-18.32-17.39,166.32,166.32,0,0,0-43-26.15,149.42,149.42,0,0,0-49-11.12l-6.32-.16c-2.11,0-4.25,0-6.37,0l-12.76,0-25.53-.06-51-.05-51.05,0-25.52,0H540.4c-2.15,0-4.22.05-6.42,0a32.22,32.22,0,0,1-3.26-.19l-1.63-.15c-.54-.06-1.07-.16-1.61-.24a55.32,55.32,0,0,1-23.87-10,70.1,70.1,0,0,1-17.67-18.87,85,85,0,0,1-10.49-23.61A97.05,97.05,0,0,1,472,280Z"/>
                                    <polygon className="cls-1"
                                             points="4262.47 272.63 4048.48 588.88 4048.48 756.32 4038.45 760.94 3936.97 807.67 3923.27 813.98 3923.27 578.09 3716.58 272.63 3869.91 272.63 3871.05 275.39 3988.56 448.97 4096.52 289.49 4107.89 272.63 4262.47 272.63"/>
                                    <path className="cls-2"
                                          d="M4263.75,272q-26.13,39.39-52.18,79.11L4159.29,431l-52.68,80.53-53.21,80.72,1-3.33,1.72,167.44.05,4.82-4.5,2.13L3927,822.12l-12.58,5.94-.13-14.08-1-118-.91-117.94,1.87,6.11-52.27-76c-17.46-25.29-34.84-50.65-52.38-75.89L3757,356.59c-17.51-25.26-35.11-50.46-52.52-75.79L3689,258.27l27.56-.22,38.34-.32,38.33-.17,38.33,0,38.33.09,10.13,0,3.77,9.3,1.13,2.76-1.46-2.72,29.08,43.6,28.92,43.7,14.44,21.87,14.38,21.91L3999,441.91h-20.87l30.67-43.52,15.37-21.73L4039.6,355l31-43.33,31.09-43.22,2.47-3.44,3.78.12c13.43.41,26.86.87,40.19,1.46s26.55,1.24,39.6,1.91,25.87,1.39,38.56,2l18.87.84Zm-2.56,1.36-20,.68-19.78.83c-13.07.58-26,1.29-38.72,2s-25.26,1.34-37.69,1.9-24.77,1.06-37.1,1.47l6.24-3.32q-14.18,22.56-28.52,45l-28.73,44.83L4042.47,389,4028,411.39,3999,456l-10,15.46L3978.12,456l-30.06-42.93-15-21.48-14.94-21.53L3888.29,327l-29.68-43.19-.83-1.22-.62-1.5-1.15-2.76,13.9,9.32-38.33.09-38.33-.05-38.33-.17-38.34-.31,12.08-22.75c17,25.58,33.89,51.29,50.83,76.93l50.78,77c16.9,25.67,34,51.23,51,76.85L3932.31,572l1.89,2.86,0,3.26L3933.27,696l-1,118-12.71-8.13,125.76-56.49-4.46,7,1.72-167.44,0-1.88,1-1.44,53.78-77.41,54.32-77.6,54.71-78.23Q4233.81,313,4261.19,273.31Z"/>
                                    <path className="cls-1" d="M2715.58,814H2557.16V272.63h158.42Z"/>
                                    <path className="cls-2"
                                          d="M2716.6,815q-39.26.69-79.11,1.67l-40,.84-40.28.73-4.19.07-.07-4.34-2.13-135.34-1.95-135.33L2547.06,408l-1.5-135.34-.12-11.07,11.72-.53c13.21-.6,26.41-1,39.61-1.44q9.9-.31,19.8-.57l19.8-.46c13.2-.29,26.4-.5,39.6-.7l19.81-.25,19.8-.18,15.08-.14.12,15.34c.38,46,.23,92.15-.34,138.17s-1.53,91.94-2.84,137.49-2.93,90.72-4.78,135.28S2719,772.12,2716.6,815Zm-2-2c-2.35-47.34-4.36-93.56-6.21-139.24s-3.47-90.71-4.79-135.4-2.25-89-2.83-133.19-.72-88.28-.35-132.5l15.21,15.2-19.8-.18-19.81-.26c-13.2-.19-26.4-.4-39.6-.7l-19.8-.45q-9.9-.24-19.8-.57c-13.2-.39-26.4-.84-39.61-1.44l11.6-11.6L2567.27,408l-1.77,135.34-1.94,135.33L2561.43,814l-4.27-4.26,38.93.72,39.16.85Q2674.58,812.19,2714.55,813Z"/>
                                    <polygon className="cls-1"
                                             points="2332.31 654.48 2321.97 674.27 2249.57 812.89 1832.08 812.89 1832.08 273.72 1990.49 273.72 1990.49 654.48 2332.31 654.48"/>
                                    <path className="cls-2"
                                          d="M2333.55,653.73l-4.82,10.6c-1.66,3.6-3.42,7.22-5.22,10.76L2313.42,695l-20.17,39.87-40.41,79.71-1,1.95-2.28,0-208.75,2.32L1832.08,821l-8,.09-.08-8.21-1.28-134.79-1.09-134.79-1-134.8-.59-67.39-.73-67.4-.14-12.7,13-.16,79.21-.94,39.6-.48,39.6-.37,14.5-.13.15,14.78q.49,47.59.46,95.19t-.36,95.19c-.24,31.73-.65,63.46-1,95.19l-.7,47.6-.83,47.59-12.18-12.17c29.35.55,58.71,1.23,87.9,2.12s58.24,1.92,87,3l85.16,3.36Q2292.55,652.48,2333.55,653.73Zm-2.48,1.5q-44.52,1.28-87.88,2.9l-85.74,3.37c-28.25,1.11-56.18,2.17-83.95,3s-55.39,1.57-83,2.12l-12,.24-.22-12.42-.83-47.59-.7-47.6c-.39-31.73-.8-63.46-1-95.19s-.4-63.46-.36-95.19.13-63.46.45-95.19l14.65,14.65-39.6-.37-39.6-.47-79.21-.95,12.85-12.86-.73,67.4-.58,67.39-1,134.8-1.09,134.79-1.28,134.79-8.12-8.12,208.74,2.1,208.75,2.33-3.27,2,42.34-78.7,21.19-39.33,10.6-19.67c1.65-3.06,3.33-6.05,5.12-9.05Z"/>
                                    <polygon className="cls-1"
                                             points="3540.85 272.63 3540.83 272.66 3463.79 417.48 3456.57 431.05 3285.45 431.05 3285.45 813.98 3127.03 813.98 3127.03 431.05 2909.31 431.05 2909.31 430.43 2916.21 417.48 2918.36 413.43 2952.66 348.96 2993.27 272.63 3540.85 272.63"/>
                                    <path className="cls-2"
                                          d="M3542.12,271.94a1.47,1.47,0,0,1-.08,1.51l.07-.11-82.44,159.35-1,1.84-2.15,0-171.12,1.78,5.28-5.29L3294.24,814l.08,8.72-8.87.07L3127,824.05l-10,.08L3117,814l-1.36-191.47-.73-95.73-1-95.74L3127,444.17l-108.86,1.19-54.43.45q-27.21.22-54.43.28l-15,.05,0-15.1v-4.33l1.77-3.35L2917,383.89,2938,344.47l21.2-39.34,21.31-39.28,4.21-7.74,8.53.1c23.34.25,46.7.48,70,.84s46.69.72,70,1.24c46.59,1,93,2.22,139,3.61l136.52,4.29,67.09,2Zm-2.55,1.38-70.65,1.75-69.81,2-137.27,4.29c-45.28,1.38-90.13,2.65-134.8,3.6-22.35.53-44.63.86-66.93,1.25s-44.55.59-66.84.84L3006,279.4,2985.34,319l-20.78,39.56-20.92,39.48-21,39.43,1.76-7.07V431l-15.05-15q27.22.09,54.43.28l54.43.45L3127,417.92l13.26.14-.14,13-1,95.74-.74,95.73L3137.09,814,3127,803.92l158.42,1.27-8.8,8.79L3280.16,431l.05-5.33,5.24.05,171.12,1.78-3.09,1.86L3539.55,272l.07-.11a1.37,1.37,0,0,0-.23.72A1.47,1.47,0,0,0,3539.57,273.32Z"/>
                                    <path className="cls-1"
                                          d="M1642.19,431.3c0,135.5-76.35,226.14-207.61,226.14H1240.3V814H1083.74V500.89H1447.2c40.39,0,63.73-28.39,63.73-70.5,0-43-23.34-69.58-63.73-69.58H1083.74v-1l84.19-158.25h267.28C1565.84,201.52,1642.19,294.89,1642.19,431.3Z"/>
                                    <path className="cls-2"
                                          d="M1643.64,431.3c-.2,22.64-2.3,45.31-7.28,67.42a239.61,239.61,0,0,1-9.58,32.59,219.77,219.77,0,0,1-14.15,30.9c-11.19,19.7-25.49,37.84-43.06,52.33a185.81,185.81,0,0,1-28,19.37,200.17,200.17,0,0,1-31.18,13.86,213.77,213.77,0,0,1-33,8.55l-4.21.73c-1.41.24-2.81.51-4.22.66l-8.48,1.06c-1.41.2-2.83.29-4.25.4l-4.26.33-4.26.34c-1.42.11-2.84.11-4.27.17l-8.54.28-8.46.1-16.91.21-33.83.45-135.31,1.79,5.4-5.4.91,78.27.71,78.27.07,7-7.09,0-156.56,1.07-8,0,0-8.15-2-313.09-.06-10,10.12-.06,235.32-1.26,117.66-.68,7.35-.05h1.84c.59,0,1.28,0,1.76,0,1-.05,2.1,0,3.14-.11a59,59,0,0,0,12-1.91,46.75,46.75,0,0,0,10.79-4.37,42.11,42.11,0,0,0,9-6.86,49.37,49.37,0,0,0,11.86-20,79.4,79.4,0,0,0,3.53-25,80.69,80.69,0,0,0-3.8-24.9,46.42,46.42,0,0,0-11.93-19.26,40.71,40.71,0,0,0-9-6.33,48.06,48.06,0,0,0-10.69-3.89,62.06,62.06,0,0,0-11.9-1.57c-1-.05-2.07,0-3.11-.05l-3.59,0-7.35.06-58.83.49-58.83.37q-117.66.74-235.32.18l-14.94-.07.06-14.82v-1l0-3.79,1.72-3.2,21.26-39.45,21.33-39.41c7.15-13.12,14.24-26.27,21.44-39.36l21.56-39.29,3.93-7.16,7.81.11q77.05,1.09,154.1,3l77,1.94,19.27.49,9.63.24,4.81.13,2.41.06,2.47.11,9.89.47,9.86.92,2.46.24,2.45.34,4.91.7c1.63.25,3.27.43,4.89.73l4.87.94a220.52,220.52,0,0,1,38,10.84,192.69,192.69,0,0,1,35.12,18.08A187.53,187.53,0,0,1,1605.09,283a215.93,215.93,0,0,1,18.11,34.53,247.75,247.75,0,0,1,11.94,37l1.15,4.71,1,4.76c.63,3.17,1.34,6.32,1.8,9.53s1.06,6.37,1.5,9.57l1.18,9.61A369.72,369.72,0,0,1,1643.64,431.3Zm-2.9,0a367.38,367.38,0,0,0-2.41-38.25,276.12,276.12,0,0,0-7.2-37.55,229.27,229.27,0,0,0-12.57-36,206.45,206.45,0,0,0-18.6-33.09,183.76,183.76,0,0,0-24.61-28.61,173.29,173.29,0,0,0-30-22.59,178.18,178.18,0,0,0-34-15.62,202.35,202.35,0,0,0-36.43-8.47l-4.63-.65c-1.55-.21-3.11-.3-4.66-.45l-4.67-.43-2.33-.21-2.34-.11-9.35-.4-9.38,0h-2.34l-2.41.06-4.81.13-9.63.24-19.27.49-77,1.94q-77,1.83-154.1,3l11.74-7-20.53,39.83c-6.83,13.29-13.77,26.51-20.66,39.77l-20.76,39.71-20.84,39.68,1.75-7v1l-14.89-14.89q117.66-.5,235.32.18l58.83.37,58.83.49,7.35.06,3.76,0c1.42.05,2.83.06,4.25.15a88.93,88.93,0,0,1,17.16,2.58,74.94,74.94,0,0,1,16.76,6.48,67.18,67.18,0,0,1,26,25.16,78,78,0,0,1,7.17,16.12,106.57,106.57,0,0,1,4.6,33.08,104.56,104.56,0,0,1-5.29,32.94,80.47,80.47,0,0,1-7.37,15.79A68.12,68.12,0,0,1,1500,493.31a66.74,66.74,0,0,1-14.49,10.63,72.81,72.81,0,0,1-16.49,6.42,83.22,83.22,0,0,1-17,2.5c-1.41.07-2.81.06-4.21.09-.75,0-1.29,0-1.92,0h-1.84l-7.35,0-117.66-.68L1083.74,511l10.07-10.06-2,313.09-8.1-8.09L1240.3,807l-7,7,.72-78.27.91-78.27L1235,652l5.34.07,135.31,1.78,33.83.45,16.91.21,8.46.1,8.37-.09c1.39,0,2.79,0,4.18-.08l4.18-.23,4.18-.23c1.4-.07,2.79-.13,4.18-.3l8.32-.85c1.4-.11,2.77-.35,4.15-.55l4.14-.62a200.81,200.81,0,0,0,32.55-7.7,195.11,195.11,0,0,0,30.79-13.06,182.8,182.8,0,0,0,27.79-18.65l3.22-2.68,1.62-1.34,1.53-1.43c2-1.92,4.11-3.8,6.11-5.75l5.8-6.07c1.89-2.05,3.65-4.23,5.49-6.34a192.54,192.54,0,0,0,19-27.63,226.64,226.64,0,0,0,23.49-62.79C1638.87,476.27,1640.68,453.75,1640.74,431.3Z"/>
                                </svg>


                            </a>
                        </h1>
                    <Routes>
                        <Route path="/" element={<StarterCard
                            show = { false }
                            title = { cards[0].title }                            btn1 = { cards[0].btn1 }
                            btn1To = { cards[0].btn1To }
                            btn2 = { cards[0].btn2 }
                            btn2To = { cards[0].btn2To }
                            persone  = { persone }
                            resetState = { resetState }
                            showOverlay = { knowAbout }
                            toggleOverlay = { toggleKnowAbout }
                        />
                        } />

                        <Route path="/Equally" element={<MainCard
                            show = { true }
                            flag ={ false }
                            style = { commonStyles.cardTitle }
                            title = { cards[1].title }
                            btn1 = { cards[1].btn1 }
                            btn1To = { cards[1].btn1To }
                            btn2 = { cards[1].btn2 }
                            persone  = { persone }
                            onCalcola  = { handleCalcola }
                            errorCalcola = { errorCalcola }
                            errorBadge = { errorBadge }
                            showOverlay = { knowAbout }
                            toggleOverlay = { toggleKnowAbout }
                            saveSession = { saveSession }
                            downloadSession = { downloadSession }

                        />
                        }/>

                        <Route path="/Individually" element={<MainCard
                            show = { true }
                            flag = { true }
                            style = { commonStyles.cardTitleI }
                            title = { cards[2].title }
                            btn1 = { cards[2].btn1 }
                            btn1To = { cards[2].btn1To }
                            btn2 = { cards[2].btn2 }
                            persone  = { persone }
                            onCalcola  = { handleCalcola }
                            errorCalcola = { errorCalcola }
                            errorBadge = { errorBadge }
                            showOverlay = { knowAbout }
                            toggleOverlay = { toggleKnowAbout }
                            saveSession =  { saveSession }
                            downloadSession = { downloadSession }
                        />
                        }/>

                        <Route path="Equally/addFriend" element={<FormPersona
                            flag ={ false }
                            onAggPersone = { handlePersona }
                            onBack = { handleBack }
                            persone  = { persone }
                            errorNome = { formErrorNome }
                            errorSpesaPers = { formErrorSpesaPers }
                            errorSpesaTot = { formErrorSpesaTot }
                            showOverlay = { knowAbout }
                            toggleOverlay = { toggleKnowAbout }
                        />
                        }/>

                        <Route path="Individually/addFriend" element={<FormPersona
                            flag = { true }
                            onAggPersone = { handlePersona }
                            onBack = { handleBack }
                            persone  = { persone }
                            errorNome = { formErrorNome }
                            errorSpesaPers = { formErrorSpesaPers }
                            errorSpesaTot = { formErrorSpesaTot }
                            showOverlay = { knowAbout }
                            toggleOverlay = { toggleKnowAbout }
                        />
                        }/>

                        <Route path="/Results" element={<Risultati
                            persone  = { persone }
                            openAlert = { infoAlert }
                        />
                        }/>

                        <Route path="/Equally/FriendList" element={<ListaPersone
                            persone = { persone }
                            flag = { false }
                            onDelete = { handleCancellaPersona }
                            onBack = { handleBack }
                        />
                        }/>

                        <Route path="/Individually/FriendList" element={<ListaPersone
                            persone = { persone }
                            flag = { true }
                            onDelete = { handleCancellaPersona }
                            onBack = { handleBack }
                        />
                        }/>

                    </Routes>
                </div>

                {/*Alerts*/}

                <animated.div className="fixed-top alert alert-danger" role="alert" style={errAlertStyles}>
                    { AlertMessage }
                </animated.div>

                <animated.div className="fixed-bottom alert alert-info" role="alert" style={infoAlertStyles}>
                    { AlertMessage }
                </animated.div>

                <animated.div className="fixed-bottom alert alert-success" role="alert" style={succAlertStyles}>
                    { AlertMessage }
                </animated.div>

                {/*Info button*/}
                <animated.div className={"fixed-top"} style={infoError === "err"? errInfo : { opacity: 1 }}>
                    <button className={"infobtn " + infoError} onClick={() => {
                        if (window.location.pathname !== "/Individually/FriendList" && window.location.pathname !== "/Equally/FriendList" && window.location.pathname !== "/Results") {
                            toggleKnowAbout(!knowAbout)
                        }
                    }}>
                        <i className="bi bi-info-square">
                            {!knowAbout?
                                <svg xmlns="http://www.w3.org/2000/svg" width={widthInfo} height={heightInfo} fill="currentColor"
                                     className="bi bi-info-square" viewBox="0 0 16 16">
                                    <path
                                        d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                                    <path
                                        d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                                </svg>
                                :
                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor"
                                     className="bi bi-x-square" viewBox="0 0 16 16">
                                    <path
                                        d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                                    <path
                                        d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                </svg>
                            }
                        </i>
                    </button>
                </animated.div>

                <div className="fixed-bottom" style={{fontSize: "15px"}}>Version 1.0.0</div>
            </div>
        </>
    );
}

export default App;